export interface IImportCsvRow {
  rowId: number;
  createdCount?: number;
  updatedCount?: number;
  messages: string[];
  errorsCount: number;
}

export interface IImportCsvSummary {
  totalCreated: number;
  totalUpdated: number;
}

export const summarizeImportRows = (
  rows: readonly IImportCsvRow[]
): IImportCsvSummary =>
  rows.reduce(
    (acc, row) => ({
      totalCreated: acc.totalCreated + (row.createdCount ?? 0),
      totalUpdated: acc.totalUpdated + (row.updatedCount ?? 0),
    }),
    { totalCreated: 0, totalUpdated: 0 }
  );

export const formatImportRowsSuccess = (
  rows: readonly IImportCsvRow[]
): string => {
  const { totalCreated, totalUpdated } = summarizeImportRows(rows);
  return `Import completed. Added: ${totalCreated}, Updated: ${totalUpdated}.`;
};

export const readFileAsText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string) ?? '');
    reader.onerror = () =>
      reject(reader.error ?? new Error('File read failed'));
    reader.readAsText(file);
  });

export const downloadCsvWithTimestamp = (
  fileNamePrefix: string,
  csvContent: string
): void => {
  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');
  const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
    now.getDate()
  )}${pad(now.getHours())}${pad(now.getMinutes())}`;
  const fileName = `${fileNamePrefix}-${timestamp}.csv`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
